import { useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import type { BookingFormValues } from '../types/booking'

interface AdditionalGuestsProps {
  guestCount: number
}

const AdditionalGuests = ({ guestCount }: AdditionalGuestsProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<BookingFormValues>()

  const numberOfAdditionalGuests = Math.max(0, guestCount - 1)

  if (numberOfAdditionalGuests === 0) {
    return null
  }

  const additionalGuestErrors = errors.additionalGuests
  const arrayLevelError =
    additionalGuestErrors && !Array.isArray(additionalGuestErrors) ? additionalGuestErrors.message : undefined

  return (
    <section aria-labelledby="additional-guests-heading" className="superz-widget-panel p-6">
      <header className="mb-4">
        <p className="text-xs uppercase tracking-[0.3em] text-widget-accent/70">Guest List</p>
        <h2 id="additional-guests-heading" className="font-display text-3xl text-widget-accent">
          Additional Guests
        </h2>
        <p className="mt-2 text-sm text-widget-accent/70">
          Please share the names of everyone joining this private consultation in addition to the main contact person.
        </p>
      </header>

      <div className="grid gap-4 md:grid-cols-2">
        {Array.from({ length: numberOfAdditionalGuests }).map((_, index) => {
          const fieldError =
            Array.isArray(additionalGuestErrors) && additionalGuestErrors[index]
              ? additionalGuestErrors[index]?.message
              : undefined

          return (
            <label key={index} className="flex flex-col gap-2">
              <span className="text-xs uppercase tracking-[0.3em] text-widget-accent/60">
                Guest {index + 2} <span className="text-widget-secondary">*</span>
              </span>
              <input
                type="text"
                {...register(`additionalGuests.${index}` as const)}
                placeholder="Full name"
                className={clsx(
                  'w-full rounded-2xl border bg-widget-primary/15 px-4 py-3 text-base text-widget-accent placeholder:text-widget-accent/40 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-widget-secondary/30 focus:border-widget-secondary',
                  fieldError ? 'border-red-300/60' : 'border-widget-primary/40',
                )}
              />
              {fieldError && (
                <span role="alert" className="text-xs text-red-200">
                  {fieldError}
                </span>
              )}
            </label>
          )
        })}
      </div>

      {arrayLevelError && (
        <p role="alert" className="mt-3 rounded-2xl bg-red-500/10 px-4 py-3 text-sm text-red-200">
          {arrayLevelError}
        </p>
      )}
    </section>
  )
}

export default AdditionalGuests

